import { render, staticRenderFns } from "./JobDescription.vue?vue&type=template&id=c40dd40a&"
import script from "./JobDescription.vue?vue&type=script&lang=js&"
export * from "./JobDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports